export default "__VITE_ASSET__DSgUFX3w__"